import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigProvider } from 'providers/config/config';
import { GenProvider } from 'providers/gen/gen';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent implements OnInit {
  nome: any;
  foto: string;
  constructor( public genProvider: GenProvider, private router: Router, public configProvider: ConfigProvider) {

   }
   ngOnInit(): void {
     setTimeout(() => {
    this.nome = this.genProvider.parametros.nome
    this.foto = 'assets/perfil/' + this.nome.trim().toUpperCase().substring(0, 1) + '.jpg';
     }, 1000);
    }
    clearLogin(){
      this.configProvider.clearStorage();
      this.router.navigate(['/login'])
    }
}



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-header/app-header.component.ts